import { render, staticRenderFns } from "./patrolList-add-or-update.vue?vue&type=template&id=70c31bbc&scoped=true&"
import script from "./patrolList-add-or-update.vue?vue&type=script&lang=js&"
export * from "./patrolList-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./patrolList-add-or-update.vue?vue&type=style&index=0&id=70c31bbc&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c31bbc",
  null
  
)

export default component.exports